import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import React, { useState, useEffect } from "react";
import DvirImg from "../../assets/img/Team/Dvirco.jpg";
import JuanImg from "../../assets/img/Team/juan.jpg";
import Jennifer from "../../assets/img/Team/Jennifer.jpg";
import Pavia from "../../assets/img/Team/Pavia.jpg";
import Kareem from "../../assets/img/Team/Kareem.jpg";
import Geetha from "../../assets/img/Team/Gheeta.jpg";
import LayaImg from "../../assets/img/Team/Laya.jpg";
import Arthur from "../../assets/img/Team/Arthur.jpg";
import PhuongPham from "../../assets/img/Team/Phuong.jpg";
import LinkedInLogo from "../../assets/img/Social/linkedin-logo.svg";
import GithubLogo from "../../assets/img/Social/github-mark.svg";
import TeamCard from "../TeamCard/TeamCard";
import styles from "./TeamSection.module.css";
import { motion } from "framer-motion";

const TeamMemberCard = (props) => {
  return (
    <div className={styles.teamMemberCard}>
      <div className={styles.teamMemberCardHeader}>
        <img src={props.image} alt="profile picture"></img>
        <h3>{props.name}</h3>
        <p>
          <strong>{props.education}</strong> | {props.title}
        </p>
      </div>

      {props.email && (
        <a href={`mailto:${props.email}`} className={styles.emailLink}>
          <EmailOutlinedIcon fontSize="small" />
          <span className={styles.emailText}>{props.email}</span>
        </a>
      )}
      {props.githubURL && (
        <a href={props.githubURL}>
          <img src={GithubLogo} alt="github logo"></img>
        </a>
      )}
      {props.email && (
        <a href={`mailto:${props.email}`} className={styles.emailLink}>
          <EmailOutlinedIcon fontSize="small" />
          <span className={styles.emailText}>{props.email}</span>
        </a>
      )}
      <div></div>
    </div>
  );
};

const TeamSection = () => {
  const [team, setTeam] = useState([
    {
      name: "Geetha KCN",
      title: "CTO & Full Stack Software Developer",
      education: "Master of Science in Computer Science (MSCS)",
      image: Geetha,
      about:
        "A hard-working and integral individual who is always ready to take on any challenge, with strong leadership and teamwork skills. A leader and a mentor to many, always willing to help others learn and grow.",
      LinkedInURL: "https://www.linkedin.com/in/geethakoyada/",
      githubURL: "https://github.com/geethakcn",
      email: "Team@Firstland.Homes.com",
      category: ["leadership", "development"],
    },
    {
      name: "Dvir Cohen",
      title: "President & Full Stack Software Developer",
      education: "MBA in Finance, CAMS",
      image: DvirImg,
      about:
        "Ambitious experienced leader with over 22 years of work experience in managing complex projects and driving business transformation initiatives and financial services.",
      LinkedInURL: "https://www.linkedin.com/in/dvir-cohen-cams-mba-51234445/",
      githubURL: "https://github.com/dvirco123",
      email: "Dvirco@Firstland.Homes.com",
      category: "leadership",
    },
    //   name: "Kareem Khusenov",
    //   education: "Bachelor of Computer Science",
    //   title: "Full-Stack Developer",
    //   image: Kareem,
    //   about:
    //     "A driven and skilled Full-Stack Software Developer, enthusiastic about harnessing the power of coding and technology to build robust and scalable solutions.",
    //   LinkedInURL: "https://www.linkedin.com/in/kareem-khusenov/",
    //   githubURL: "https://github.com/abdukarim17",
    //   category: "development"
    // },
    {
      name: "Laya Aluri",
      education:
        "Master of Science in Information Technology and Management (MSITM)",
      title: "Senior Full-Stack Developer (MS)",
      image: LayaImg,
      about:
        "Highly skilled in front-end, back-end, and API integration, with a commitment to leveraging technology for scalable solution development.",
      LinkedInURL: "https://www.linkedin.com/in/laya-aluri-790575183/",
      githubURL: "https://github.com/",
      email: "Team@Firstland.Homes.com",
      category: "development",
    },
    // {
    //   name: "Tejas Sathe",
    //   title: "Senior Full Stack Software Developer (Volunteer)",
    //   education: "Master of Science in Business Analytics (MS)",
    //   image: "",
    //   about:
    //     "Highly skilled individual with a rich background in front end, backend, and API integration. With his experience and a keen eye for detail, Geetha excels at bridging the gap between complex backend logic and intuitive front-end designs.",
    //   LinkedInURL: "https://www.linkedin.com/in/paviabera/",
    //   githubURL: "https://github.com/paviabera",
    //   category: "development"
    // },
    {
      name: "Dr. Pavia Bera",
      title: "Machine Learning Consultant (Volunteer)",
      education: "PhD in Electrical Engineering",
      image: Pavia,
      about:
        "Actively seeking better opportunities within the data analysis/machine learning/AI industry which will not only utilize my current skills but also will help me acquire some new ones.",
      LinkedInURL: "https://www.linkedin.com/in/paviabera/",
      githubURL: "https://github.com/paviabera",
      email: "Team@Firstland.Homes.com",
      category: "consulting",
    },
    // {
    //   name: "Phuong Pham",
    //   education: "B.S in Business Analytics",
    //   title: "Data Analyst",
    //   image: PhuongPham,
    //   about:
    //     "A highly motivated and analytical individual, passionate about using data analysis to drive transformative advancements in financial services.",
    //   LinkedInURL: "https://www.linkedin.com/in/phuong-pham-b91037249/",
    //   githubURL: "https://www.github.com",
    //   category: "development"
    // },
    {
      name: "Dr. Jennifer Adorno",
      title: "Technology Consultant",
      education: "PhD in Computer Science and Engineering",
      image: Jennifer,
      about:
        "A brilliant and accomplished professional with expertise in computer science and engineering. Her exceptional skills drive innovation and success.",
      LinkedInURL: "https://www.linkedin.com/in/jenniferadorno/",
      githubURL: "https://github.com/jadorno",
      email: "Team@Firstland.Homes.com",
      category: "consulting",
    },
    {
      name: "Arthur Adelson",
      title: "Treasurer & Mentor",
      education: "Bachelor of Science in Accounting",
      image: Arthur,
      about:
        "Exceptionally experienced and wise individual adorned with vast knowledge in various domains. A mentor to many, always willing to share his knowledge and wisdom with others. A true inspiration to all who know him.",
      email: "Team@Firstland.Homes.com",
      category: "consulting",
    },
  ]);

  const [filter, setFilter] = useState("all");
  const [filteredTeam, setFilteredTeam] = useState(team);
  const [showAll, setShowAll] = useState(false);
  const [displayedTeam, setDisplayedTeam] = useState([]);

  useEffect(() => {
    let teamToFilter = team;
    if (filter !== "all") {
      teamToFilter = team.filter((member) =>
        Array.isArray(member.category)
          ? member.category.includes(filter)
          : member.category === filter
      );
    }

    setFilteredTeam(teamToFilter);

    if (showAll) {
      setDisplayedTeam(teamToFilter);
    } else {
      setDisplayedTeam(teamToFilter.slice(0, 3));
    }
  }, [filter, team, showAll]);

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.1,
        duration: 0.5,
        ease: "easeOut",
      },
    }),
  };

  const handleViewMoreClick = () => {
    setShowAll(true);
  };

  const handleViewLessClick = () => {
    setShowAll(false);
  };

  return (
    <section className={styles.teamSection}>
      <motion.div
        className={styles.titleContainer}
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <h2 className={styles.title}>Our Talented Team</h2>
        <p className={styles.subtitle}>
          Meet the experts behind FirstLand's success who are passionate about
          creating exceptional real estate experiences
        </p>
      </motion.div>

      <motion.div
        className={styles.filterContainer}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.2 }}
      >
        <button
          className={`${styles.filterButton} ${
            filter === "all" ? styles.active : ""
          }`}
          onClick={() => setFilter("all")}
        >
          All Team Members
        </button>
        <button
          className={`${styles.filterButton} ${
            filter === "leadership" ? styles.active : ""
          }`}
          onClick={() => setFilter("leadership")}
        >
          Leadership
        </button>
        <button
          className={`${styles.filterButton} ${
            filter === "development" ? styles.active : ""
          }`}
          onClick={() => setFilter("development")}
        >
          Development
        </button>
        <button
          className={`${styles.filterButton} ${
            filter === "consulting" ? styles.active : ""
          }`}
          onClick={() => setFilter("consulting")}
        >
          Consulting
        </button>
        {/* <button 
          className={`${styles.filterButton} ${filter === 'marketing' ? styles.active : ''}`}
          onClick={() => setFilter('marketing')}
        >
          Marketing
        </button> */}
      </motion.div>

      <div className={styles.teamMembersContainer}>
        <div className={styles.teamMembersList}>
          {displayedTeam.map((member, index) => (
            <motion.div
              key={index}
              custom={index}
              initial="hidden"
              animate="visible"
              variants={cardVariants}
              className={styles.teamCardWrapper}
            >
              <TeamCard
                image={member.image}
                name={member.name}
                education={member.education}
                title={member.title}
                about={member.about}
                linkedInURL={member.LinkedInURL}
                githubURL={member.githubURL}
                email={member.email}
              />
            </motion.div>
          ))}
        </div>

        {displayedTeam.length < filteredTeam.length && !showAll ? (
          <motion.div
            className={styles.viewMoreContainer}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <button
              className={styles.viewMoreButton}
              onClick={handleViewMoreClick}
            >
              <motion.span
                initial={{ opacity: 1 }}
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                View {filteredTeam.length - 3} More Team Members
              </motion.span>
            </button>
          </motion.div>
        ) : (
          showAll && (
            <motion.div
              className={styles.viewMoreContainer}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <button
                className={styles.viewMoreButton}
                onClick={handleViewLessClick}
              >
                <motion.span
                  initial={{ opacity: 1 }}
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.2 }}
                >
                  View Less
                </motion.span>
              </button>
            </motion.div>
          )
        )}
      </div>
    </section>
  );
};

export default TeamSection;
